export default __webpack_public_path__ + "static/media/foodieUi.3f43ab31.jpg";